export default "__VITE_ASSET__QHEM_otQ__"